module.exports = __webpack_public_path__ + "img/img_03.368dcc84.webp";